export const FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_REQUEST = 'FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_REQUEST'
export const FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_SUCCESS = 'FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_SUCCESS'
export const FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_FALUIRE = 'FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_FALUIRE'
